import React, {Component} from 'react';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import Integration from './Integration';
import InlineTip from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineTip';
import InlineButton from 'shared/components/InlineButton';
import styles from '../AccountPageStyles';
import * as Colors from 'material-ui/styles/colors';
import InlineNotification from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineNotification';
import _ from 'lodash';
import {checkCircle} from 'shared/icons';
import {Integrations as IntegrationsData} from '../AccountPageSectionsData';

@connectWithRouter(state => ({
  templateTagSets: state.accountPage.templateTagSets,
}))
export class Integrations extends Component {
  state = {
    statusMessage: null,
  };

  requestIntegration() {
    window.Intercom(
      'showNewMessage', // eslint-disable-line new-cap
      'Hello Crazylister\n' + "I'd like to request integration for my listing software:\n"
    );
  }

  render() {
    const {templateTagSets, selectedTemplateTagSetId} = this.props;
    const {statusMessage} = this.state;
    return (
      <div style={styles.pageContentContainer}>
        <div id={'cla-integrations-title'} style={styles.h1}>
          3rd Party Integrations
        </div>
        <div>
          Easily integrate CrazyLister templates with your 3rd party listing solution!
          <br />
          Here's how:
          <div style={{marginTop: 5}}>
            1. <b>Select</b> your listing solution from the list below
            <br />
            2. <b>Create</b> a template with CrazyLister
            <br />
            3. Click <b>Publish</b> from the editor and <b>Copy</b> your template to the 3rd party listing solution
            <br />
          </div>
        </div>
        <InlineTip
          style={{height: 80, marginTop: 15, marginBottom: 15, marginLeft: 10, marginRight: 10, maxWidth: 820}}
          tipId="unsupportedIntegration"
        >
          If you use a solution not yet supported by Crazylister{' '}
          <InlineButton id={'cla-integration-tip-button-req'} onClick={this.requestIntegration}>
            Request Integration
          </InlineButton>
        </InlineTip>
        <InlineNotification
          open={!!statusMessage}
          style={{height: 80, marginTop: 15, marginBottom: 15, marginLeft: 10, marginRight: 10, maxWidth: 820}}
          onRequestClose={() => {
            this.setState({statusMessage: null});
          }}
          iconPath={checkCircle}
        >
          {statusMessage}
        </InlineNotification>
        <div style={{display: 'flex', flexWrap: 'wrap', maxWidth: 840}}>
          {_.sortBy(templateTagSets, 'order').map(templateTagSet => (
            <Integration
              key={templateTagSet.id}
              checked={selectedTemplateTagSetId === templateTagSet.id}
              templateTagSet={templateTagSet}
              onChangeWithMessage={message => this.setState({statusMessage: message})}
            />
          ))}
        </div>
        <hr />
        <div style={{fontFamily: 'roboto', fontSize: 12, color: Colors.grey400, marginBottom: 15}}>
          <p>All mentioned logos and trademarks, registered or not, are the sole property of such trademarks owners.</p>
          <p>
            The use of the aforementioned logos is to allow a better orientation identifying each of the services and
            for such purpose only.
          </p>
          <p>
            CrazyLister supports all of the above mentioned services but doesn't necessarily has official business
            collaboration with any of them.
          </p>
        </div>
      </div>
    );
  }
}

export default _.assign(Integrations, IntegrationsData);
